export const BUSINESS_ENTERPRISE_SUCCESS_BENEFIT_ENFORCE_POLICIES = {
  "en": "Enforce access and security policies that scale with your business",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Enforce access and security policies that scale with your business",
  "it": "Enforce access and security policies that scale with your business",
  "ja": "Enforce access and security policies that scale with your business",
  "ko": "Enforce access and security policies that scale with your business",
  "nl": "Enforce access and security policies that scale with your business",
  "pt-pt": "Enforce access and security policies that scale with your business",
  "sv": "Enforce access and security policies that scale with your business",
  "zh": "Enforce access and security policies that scale with your business"
}